import { render } from "./Dialog.vue?vue&type=template&id=02717c3a&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=02717c3a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02717c3a"

export default script